<template>
    <div>
        <button class="close" @click="$emit('close',false)">Х</button>
        <h3>Версия для слабовидящих</h3>
        <div>
            <div>
            <h4>Размер шрифта</h4>
                <div class="buttons size">
                    <button @click="setSightless(0,'standart')" :class="sightless[0].standart?'active':''">А</button>
                    <button @click="setSightless(0,'medium')" :class="sightless[0].medium?'active':''" class="medium">А</button>
                    <button @click="setSightless(0,'big')" :class="sightless[0].big?'active':''" class="big">А</button>
                </div>
            </div>
            <div>
            <h4>Цвет</h4>
                <div class="buttons">
                    <button @click="setSightless(1,'standart')" :class="sightless[1].standart?'active':''" class="standart">Стандартный</button>
                    <button @click="setSightless(1,'inversion')" :class="sightless[1].inversion?'active':''" class="inversion">Инверсия</button>
                    <button @click="setSightless(1,'blue')" :class="sightless[1].blue?'active':''" class="blue">Синий</button>
                </div>
            </div>
            <div>
            <h4>Межбуквенный интервал</h4>
                <div class="buttons interval-s">
                    <button @click="setSightless(2,'standart')" :class="sightless[2].standart?'active':''">аб</button>
                    <button @click="setSightless(2,'medium')" :class="sightless[2].medium?'active':''" class="interval-s-medium">аб</button>
                    <button @click="setSightless(2,'big')" :class="sightless[2].big?'active':''" class="interval-s-big">аб</button>
                </div>
            </div>
            <div>
                <h4>Межстрочный интервал</h4>
                <div class="buttons interval-m">
                    <button @click="setSightless(3,'standart')" :class="sightless[3].standart?'active':''">Стандартный интервл</button>
                    <button @click="setSightless(3,'medium')" :class="sightless[3].medium?'active':''" class="interval-m-medium">Стандартный интервл</button>
                    <button @click="setSightless(3,'big')" :class="sightless[3].big?'active':''" class="interval-m-big">Стандартный интервл</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    methods:{
        setSightless(index,text){
            console.log(index,text)
            for(let key in this.sightless[index]){
                this.sightless[index][key] = false
                document.querySelector('html').classList.remove(key+index)
            }
            this.sightless[index][text] = true
            
            document.querySelector('html').classList.add(text+index)
        }
    },
    data(){
        return{
            sightless:[
                {standart:true,medium:false,big:false},
                {standart:true,inversion:false,blue:false},
                {standart:true,medium:false,big:false},
                {standart:true,medium:false,big:false},
            ]
        }
    }
}
</script>
<style>
    .sightless .modal-form>div{
        padding: 64px;
        display: flex;
        flex-direction: column;
        gap: 32px;
    }
    .sightless .modal-form>div>div{
        display: flex;
        flex-direction: column;
        gap: 24px;
    }
    .sightless .modal-form .buttons{
        display: flex;
        gap: 8px;
    }
    .sightless .modal-form>div>div>div{
        display: flex;
        flex-direction: column;
        gap: 8px;

    }
    .sightless .modal-form>div *{
        margin: 0;
        color: #0D3041;
    }
    .sightless .modal-form>div h3{
        font-size: 22px
    }
    .sightless .modal-form>div h4{
        font-size: 16px;
        font-weight: 400;
    }
    .sightless .modal-form>div button{
        border-radius: 8px;
        border: #EDF6FF 2px solid;
        min-height: 42px;
        min-width: 64px;
        background-color: var(--background);
        padding: 12px 11px;
        font-size: 14px !important;   
        letter-spacing:0px !important;
        line-height:130% !important
    }
    .sightless .modal-form>div button:hover,
    .sightless .modal-form>div button.active{
        border: #174E72 2px solid;
        cursor: pointer;
    }

    .sightless .modal-form .close{
        width: 42px;
        height: 42px;
        min-width: 42px;
        font-size: 20px;
        color: #fff;
        background-color: #174E72;
        border: none;
        padding: 0;
    }

    .sightless .modal-form>div button.medium{
        font-size: 22px !important;
    }
    .sightless .modal-form>div button.big{
        font-size: 26px !important;
    }
    .sightless .modal-form>div button.standart{
        color: #FFF;
        background-color: #174E72;   
        width:140px ;
    }
    .sightless .modal-form>div button.standart{
        color: #FFF;
        background-color: #174E72;   
    }
    .sightless .modal-form>div button.standart:hover,
    .sightless .modal-form>div button.standart.active{
        background-color:#007BB8;
    }  
    .sightless .modal-form>div button.inversion{
        background-color:#0D0D0D;
        color: #FFF;
        width: 115px;
    }
    .sightless .modal-form>div button.inversion:hover,
    .sightless .modal-form>div button.inversion.active{
        border-color: #007BB8;
        background-color:var(--white);
        color: #0D0D0D;
    }   
    .sightless .modal-form>div button.blue{
        color: #134CA2;
        background-color: #9DD9FF;   
        width: 92px;
    }   
    .sightless .modal-form>div button.blue:hover,
    .sightless .modal-form>div button.blue.active{
        border-color: #007BB8;
    }
    .sightless .modal-form>div button.interval-s-medium{
        letter-spacing:4px !important
    }
    .sightless .modal-form>div button.interval-s-big{
        letter-spacing:8px !important
    }
    .sightless .modal-form>div button.interval-m-medium{
        line-height:165% !important
    }
    .sightless .modal-form>div button.interval-m-big{
        line-height:200% !important
    }
    .sightless .modal-form .size>button{
        padding-bottom: 4px;
        padding-top: 4px;
    }
    .sightless .modal-form .interval-m>button{
        padding-bottom: 2px;
        padding-top: 2px;
    }
    @media (max-width: 1000px){

        .sightless .modal-form .buttons{
            flex-wrap: wrap;
        }
        .sightless .modal-form>div button{
            max-width: 105px;
        }
       
    }
</style>